import {
    Component, ElementRef, EventEmitter,
    HostListener, Output, ViewContainerRef
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Auth } from '../shared/services/auth';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { SharedData } from '../shared/sharedData';
import { ToasterComponent } from '../toasterComponent/toasterComponent';


@Component({
    selector: 'ToolsMenu',
    templateUrl: 'designationList.html',
})

export class DesignationPageComponent {
    @Output()
    public updateRate: any = new EventEmitter();
    public pageSize: any = 10;
    public page = 1;
    public startingPage: any = 1;
    public endingPage: any = 10;
    public collectionSize: any;
    public _baseUrl: any;
    public orgData: any = [];
    public trackHides = null;
    public desgData: any = [];
    public desgPageData: any = [];
    public showLoading: any = false;

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public translate: TranslateService,
        public vcr: ViewContainerRef) {

        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllDesignation();

    }

    // pagination functions
    public onPageChange(event: number): void {
        let that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        } else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            } else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllDesignation();
    }
    public OnPageSizeChanged(val) {
        this.pageSize = val;
        this.getAllDesignation();
    }

    public addDesignation() {
        this.share.saveData({ desgId: null, type: 'ADD' });
        this.router.navigate(['menu/addDesignation']);
    }

    public editDesignation(val) {
        this.share.saveData({ desgData: val, type: 'EDIT' });
        this.router.navigate(['menu/addDesignation']);
    }
    public deleteDesg(val) {
        this.share.saveData({ desgData: val, type: 'DELETE' });
        this.router.navigate(['menu/addDesignation']);
    }

    public getAllDesignation() {
        let self = this;
        self.showLoading = true;
        let url = self._baseUrl + 'v1/webAdmin/designation';
        self.http.post(url, { page: self.page, pageSize: self.pageSize }).subscribe((result) => {
            self.desgData = result.content;
            self.desgPageData = result;
            if (self.desgData.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, (error) => {
            self.showLoading = false;
        });
    }

    public empActions(val) {
        // this.hide = val;
    }
    public empTableActions(value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        } else {
            this.trackHides = value;
        }

    }

    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 100);
        }
    }
    public clicked() {
        this.trackHides = null;
    }

    public onRefresh(){
            setTimeout(()=>{
                this.getAllDesignation();
            },2000)
        
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/designationList.ts